import { render, staticRenderFns } from "./EditFooterBlockModal.vue?vue&type=template&id=2b107bb8&scoped=true&"
import script from "./EditFooterBlockModal.vue?vue&type=script&lang=js&"
export * from "./EditFooterBlockModal.vue?vue&type=script&lang=js&"
import style0 from "./EditFooterBlockModal.vue?vue&type=style&index=0&id=2b107bb8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b107bb8",
  null
  
)

export default component.exports